var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.852 6.54A7.49 7.49 0 0 0 12.502.5c-2.89 0-5.4 1.64-6.65 4.04a5.994 5.994 0 0 0-5.35 5.96c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z","fill":"currentColor"}));
}

Cloud.defaultProps = {"width":"25","height":"17","viewBox":"0 0 25 17"};

module.exports = Cloud;

Cloud.default = Cloud;
